import { render, staticRenderFns } from "./LogoFlag.vue?vue&type=template&id=359d50cc"
import script from "./LogoFlag.vue?vue&type=script&lang=js"
export * from "./LogoFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359d50cc')) {
      api.createRecord('359d50cc', component.options)
    } else {
      api.reload('359d50cc', component.options)
    }
    module.hot.accept("./LogoFlag.vue?vue&type=template&id=359d50cc", function () {
      api.rerender('359d50cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/branding/LogoFlag.vue"
export default component.exports